export interface CommitGate {
  committed: Set<string>
  lastAcceptedAt: number
}

export function createCommitGate(): CommitGate {
  return { committed: new Set(), lastAcceptedAt: Number.NEGATIVE_INFINITY }
}

export function claimCommit(gate: CommitGate, key: string, now: number, duplicateWindowMs = 500) {
  if (gate.committed.has(key) || now - gate.lastAcceptedAt < duplicateWindowMs) return false
  gate.committed.add(key)
  gate.lastAcceptedAt = now
  return true
}

export function releaseCommit(gate: CommitGate, key: string) {
  gate.committed.delete(key)
  gate.lastAcceptedAt = Number.NEGATIVE_INFINITY
}
